export const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
}

// Note: this should match the SCSS $base-transition in _variables.scss
export const baseTransition = 300

export const KEY_TAB = 9
export const KEY_ESC = 27

export const TABBABLE_ELEMENTS =
  'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])'

export const MAX_RECORDSET = 50000

// IE11 is very slow to render compared to modern browsers; it may be necessary to render table
// rows slower for it. These constants may help keep the UI responsive while the browser is
// rendering. The RENDER_DELAY should be enough time for the RENDER_INC number of items to
// completely render before the next update. For reference: 20 ms is 50 fps. The INIT_* options
// provide a way to have the first n number of items (INIT_RENDER_TOTAL) to render at a different
// rate than later items.
const ua = window.navigator.userAgent
export const IS_IE = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1
export const INIT_RENDER_DELAY = IS_IE ? 60 : 60
export const INIT_RENDER_INC = 1
export const INIT_RENDER_TOTAL = 15
export const RENDER_DELAY = IS_IE ? 40 : 60
export const RENDER_INC = IS_IE ? 1 : 20
export const DISABLE_TRANSITIONS = IS_IE
